<div class="file-attachments">
    <div class="content__heading" style="display: flex; align-items: center; justify-content: space-between;">
        <a class="content__heading__go-back" [routerLink]="['/']">
            <i class="material-icons">home</i>
        </a>
        <h1>{{ 'fileAttachments.filesTitle' | i18next }}</h1>
        <i style="color: #D97C54;" id="attachment-info" class="material-icons">info</i>
    </div>

    <div class="file-attachments" *ngIf="siteId" style="margin-top: 40px; border: solid rgba(180, 180, 180, 0.7) 1px; border-radius: 20px; padding: 20px 20px 0px 20px;">
        <div class="file-attachments-container">
            <div class="attachments-table" style="width: 100%;">
            <div class="attachments-header">
                <div class="header-cell">
                    <h3>{{ 'fileAttachments.fileName' | i18next }}</h3>
                </div>
                <div class="header-cell">
                 <h3>{{ 'fileAttachments.fileType' | i18next }}</h3>
                </div>
                <div class="header-cell">
                  <h3>{{ 'fileAttachments.fileSize' | i18next }}</h3>
                </div>
            </div>

            <div class="attachments-body" *ngIf="!isLoadingFiles">
                <div class="attachment-row" *ngFor="let file of files">
                <div class="cell">
                    <a [href]="getFileDownloadUrl(file.fileUrl)" target="_blank" class="file-link">
                    {{ file.name }}
                    </a>
                </div>
                <div class="cell">{{ file.type }}</div>
                <div class="cell">{{ file.size | fileSize }}</div>
                <div class="cell">
                    <button *ngIf="isSupervisorUser" class="btn-sm btn-danger" (click)="deleteFile(file.name)"> <i class="material-icons">close</i>
                    </button>
                </div>
                </div>
                <div class="no-files" *ngIf="files.length === 0">
                    {{ 'fileAttachments.noFiles' | i18next }}
                </div>
            </div>
            <div class="loading" *ngIf="isLoadingFiles" style="text-align: center; padding-top: 20px;">
                <i class="material-icons rotating">refresh</i>
            </div>
            </div>

            <div class="file-upload" *ngIf="isSupervisorUser" style="width: 100%; text-align: right; padding: 15px 0 15px 0;">
            <input type="file" #fileInput (change)="onFileSelected($event)" class="d-none">
            <a *ngIf="isSupervisorUser" class="button" (click)="fileInput.click()" >
                {{ "fileAttachments.addFile" | i18next }}
            </a>
            </div>
        </div>
    </div>
</div>